import { Card } from "../../../components/card.component";
import { PageHeader } from "../../../components";
import { HHAExchangeConfigAdd } from "../../../features/hhaConfig/hhaExchangeConfigAdd.component";

export function PageHHAConfigAdd() {
  return (
    <Card header={<PageHeader title="Add HHA Configuration" />}>
      <HHAExchangeConfigAdd />
    </Card>
  );
}